const { default: axios } = require("axios");

const tmpElementorWidgets = new Map([
    ["tmp_product_carousel", "product-carousel.js"],
    ["tmp_product_images", "product-images.js"],
    ["tmp_table", "table.js"],
    ["tmp_universe_menu", "universe-menu.js"],

    ["tmp_product_list", "ProductList/Widget"],
    ["tmp_spare_parts", "SpareParts/Widget"],
    ["tmp_warranty_activation", "WarrantyActivation/Widget"],
    ["tmp_warranty_activation_user", "WarrantyActivationUser/Widget"],
    ["tmp_warranty_claim", "WarrantyClaim/Widget"],
    ["tmp_quick_add_cart", "QuickAddToCart/Widget"],
    ["tmp_product_models", "ProductModels/Widget"],
    ["tmp_cart", "Cart/Widget"],
    ["tmp_checkout", "Checkout/Widget"],
    ["tmp_dealer_list", "DealerList/Widget"],
    ["tmp_dealer_login_button", "LoginButton/Widget"],
    ["tmp_instagram_feed", "InstagramFeed/Widget"],
    ["tmp_niu_stats", "NiuStats/Widget"],
    ["theme_tmp_product_price", "Price/Widget"],
    ["tmp_product_cart", "AddToCart/Widget"],
    ["tmp_vehicle_comparison", "VehicleComparison/Widget"],
    ["tmp_testride", "TestRide/Widget"],
]);

jQuery(window).on("elementor/frontend/init", function () {
    tmpElementorWidgets.forEach((path, name) => {
        elementorFrontend.hooks.addAction(
            "frontend/element_ready/" + name + ".default",
            function ($element) {
                const imported = import(`../app/widgets/${path}`);
                imported.then((imp) => {
                    imp.default($element);
                });
            }
        );
    });
});

jQuery(function () {
    if (jQuery(".tmp-menu-login")?.length > 0 || jQuery('a[href="/dealer/login"]')?.length > 0) {
        require("../app/components/Hooks/useSettings");
    }

    jQuery("body").on("click", '*[href^="#tmp-action_add-cart"]', function () {
        let t = jQuery(this);
        const url = t.attr("href");

        const loading_id = tmp.loading(t.parent());

        axios
            .post("/wp-json/tmp/v1/cart/item/" + tmp.utils.url.get_param("item_id", url), {
                qty: 1,
            })
            .then((response) => {
                if (response?.data?.code === "success") {
                    tmp.notice("Tilføjet vare til kurven");
                    tmp.cart.load();
                }
            })
            .finally(() => {
                tmp.loading_remove(loading_id);
            });
        /*tmp.wp.ajax("tmp-cart", data, function (response) {
            tmp.notice(response);
            tmp.loading_remove(loading_id);
            tmp.cart.count();
            tmp.cart.load();
        });*/
    });

    jQuery("body").on("click", ".tmp-product-cart-button", function () {
        const t = jQuery(this);
        const t_parent = t.closest(".tmp-product-cart-button-parent");
        const amount = t_parent.find(".tmp-product-cart-amount");
        let amount_val = 1;
        if (t.val() === "") {
            return;
        }
        if (amount.length) {
            amount_val = amount.val();
        }

        const loading_id = tmp.loading(t.closest(".tmp-product-cart-button-container"));

        amount.attr("disabled", "");

        axios
            .post("/wp-json/tmp/v1/cart/item/" + t.val(), {
                qty: amount_val,
            })
            .then((response) => {
                if (response?.data?.code === "success") {
                    tmp.notice("Tilføjet vare til kurven");
                    tmp.cart.load();
                }
            })
            .finally(() => {
                tmp.loading_remove(loading_id);
                amount.removeAttr("disabled").focus();
            });
    });
});
